import * as types from "./types";

export function loginUserStart(details, passwordAuth) {
  return { type: types.LOGIN_USER_START, details, passwordAuth };
}

export function toggleRememberMe(flag) {
  return { type: types.TOGGLE_REMEMBER_ME, flag };
}

export function loginUserSuccess(details) {
  return {
    type: types.LOGIN_USER_SUCCESS,
    ...details
  };
}

export function cancelAccountSuccess() {
  return {
    type: types.CANCEL_ACCOUNT_SUCCESS
  };
}

function showLoginError(params) {
  return {
    type: types.SHOW_LOGIN_ERROR,
    params
  };
}

function hideLoginError() {
  return {
    type: types.HIDE_LOGIN_ERROR
  };
}

export function loginUserFailed(params) {
  return dispatch => {
    let timer = null;
    dispatch(showLoginError(params));

    timer = setTimeout(() => {
      dispatch(hideLoginError());
      dispatch(clearPassMessages());
      clearTimeout(timer);
    }, 5000);
  };
}

export function logoutUser(flag, redirect) {
  return {
    type: types.LOGOUT_USER,
    flag,
    redirect
  };
}

export function cleanLocalStorage() {
  return {
    type: types.CLEAN_LOCAL_STORAGE
  };
}

export function setIsFirstTime() {
  return {
    type: types.SET_IS_FIRST_TIME
  };
}

export function setIsWelcome() {
  return {
    type: types.SET_IS_WELCOME
  };
}

export function showLoginPage() {
  return {
    type: types.SHOW_LOGIN_PAGE
  };
}

export function createAccountStart(details, logout) {
  return {
    type: types.CREATE_ACCOUNT_START,
    details,
    logout
  };
}

export function createAccountSuccess(details, loginId) {
  return {
    type: types.CREATE_ACCOUNT_SUCCESS,
    details,
    loginId
  };
}

export function createAccountFailure(details, loginId) {
  return {
    type: types.CREATE_ACCOUNT_FAILURE,
    details,
    loginId
  };
}

export function checkAuthStart() {
  return {
    type: types.CHECK_AUTH_START
  };
}

export function checkAuthSuccess(details) {
  return {
    type: types.CHECK_AUTH_SUCCESS,
    ...details
  };
}

export function passwordResetStart(emailid, token) {
  return {
    type: types.PASSWORD_RESET_START,
    emailid,
    token
  };
}

export function passwordResetSuccess(message) {
  return {
    type: types.PASSWORD_RESET_SUCCESS,
    message
  };
}

export function passwordResetFailure(message) {
  return {
    type: types.PASSWORD_RESET_FAILURE,
    message
  };
}

export function passwordValidateStart(token, logout) {
  return {
    type: types.PASSWORD_VALIDATE_START,
    token,
    logout
  };
}

export function passwordValidateSuccess(data) {
  return {
    type: types.PASSWORD_VALIDATE_SUCCESS,
    data
  };
}

export function passwordValidateFailure(data) {
  return {
    type: types.PASSWORD_VALIDATE_FAILURE,
    data
  };
}

export function updatePasswordAuthStart(details, logout) {
  return {
    type: types.UPDATE_PASSWORD_AUTH_START,
    details,
    logout
  };
}

export function clearPassMessages() {
  return {
    type: types.CLEAR_PASS_MESSAGES
  };
}

export function updatePasswordAuthSuccess(message) {
  return {
    type: types.UPDATE_PASSWORD_AUTH_SUCCESS,
    message
  };
}

export function updatePasswordAuthFailure(message) {
  return {
    type: types.UPDATE_PASSWORD_AUTH_FAILURE,
    message
  };
}

export function resetRegistrationFailedMessage() {
  return {
    type: types.RESET_REGISTRATION_FAILED_MEESAGE
  };
}
export function startRedirect(bool) {
  return {
    type: types.START_REDIRECT,
    bool
  };
}

export function PNSDown(bool) {
  return {
    type: types.PNS_DOWN,
    bool
  };
}

export function fetchAllClientsVersionStart() {
  return {
    type: types.FETCH_ALL_CLIENTS_VERSION_START
  };
}

export function fetchAllClientsVersionSuccess(data) {
  return {
    type: types.FETCH_ALL_CLIENTS_VERSION_SUCCESS,
    data
  };
}

export function updateClientVersionStart(data) {
  return {
    type: types.UPDATE_CLIENT_VERSION_START,
    data
  };
}

export function addClientVersionStart(data) {
  return {
    type: types.ADD_CLIENT_VERSION_START,
    data
  };
}

export function createSubUserStart(data, logout) {
  return {
    type: types.CREATE_SUB_USER_START,
    data,
    logout
  };
}

export function validateSubUserStart(token, logout) {
  return {
    type: types.VALIDATE_SUB_USER_START,
    token,
    logout
  };
}

export function validateSubUserSuccess(data) {
  return {
    type: types.VALIDATE_SUB_USER_SUCCESS,
    data
  };
}

export function validateSubUserFailure(data) {
  return {
    type: types.VALIDATE_SUB_USER_FAILURE,
    data
  };
}

export function fetchPromoDiscountStart(promo) {
  return {
    type: types.FETCH_PROMO_DISCOUNT_START,
    promo
  };
}

export function fetchPromoDiscountSuccess(data) {
  return {
    type: types.FETCH_PROMO_DISCOUNT_SUCCESS,
    data
  };
}

export function fetchPromoDiscountFailure(data) {
  return {
    type: types.FETCH_PROMO_DISCOUNT_FAILURE,
    data
  };
}

export function createPromoAccountStart(details, logout) {
  return {
    type: types.CREATE_PROMO_ACCOUNT_START,
    details,
    logout
  };
}

export function validate360Start(token, logout, redirect) {
  return {
    type: types.VALIDATE_360_START,
    token,
    logout,
    redirect
  };
}

export function validate360Failure(data) {
  return {
    type: types.VALIDATE_360_FAILURE,
    data
  };
}

export function validateIbackupStart(token, logout, redirect) {
  return {
    type: types.VALIDATE_IBACKUP_START,
    token,
    logout,
    redirect
  };
}

export function validateIbackupFailure(data) {
  return {
    type: types.VALIDATE_IBACKUP_FAILURE,
    data
  };
}
